import { Observable } from "rxjs";
import { Profile } from "../profile";

export abstract class ProfileData {
  abstract getProfile(id: number): Observable<any>;

  abstract update(profile: Profile);
}
